// extracted by mini-css-extract-plugin
export default {"mining__heading":"statrum-urls_mining__heading__d4RzL","mining__subtitle":"statrum-urls_mining__subtitle__g1GO5","mining__urls":"statrum-urls_mining__urls__dqGLj"};